import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SortType } from "@swimlane/ngx-datatable";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteFilter } from "src/app/models/Dte/DteFilter";
import { IDte } from "src/app/models/Dte/IDte";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { TipoDte } from "src/app/models/tipoDte";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { ConfigMantenedorDTE } from "./config-mantenedor-dte";
import * as FileSaver from "file-saver";
import * as JSZip from "jszip";
import { Observable, zip } from "rxjs";
import { Response } from "src/app/shared/models/Response";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { Router } from "@angular/router";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MultipleEmailValidator } from "src/app/directives/multi-email.directive";
import { SameWordEmailValidator } from "src/app/directives/same-word-email.directive";
import { SendInvoiceRequest } from "src/app/models/CorreoEnvio/SendInvoiceRequest";
import { CorreoEnvioService } from "src/app/services/CorreoEnvio.service";
import { Traza } from "src/app/models/Traza";
import { ReferenciaDte } from "src/app/models/Dte/ReferenciaDte";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { NotaCredito } from "src/app/models/NotaCredito";
import { NotaDebito } from "src/app/models/NotaDebito";
import { EmisorService } from "src/app/services/emisor.service";
import { CesionRequest } from "src/app/models/Cesion/CesionRequest";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { ActualizarEstadoSiiRequest } from "src/app/models/Dte/ActualizarEstadoSiiRequest";
import { ReenvioEmailRequest } from "src/app/models/Dte/ReenvioEmailRequest";
import { ReutilizacionMasivaRequest } from "src/app/models/Dte/ReutilzacionMasivaRequest";
import { PersonasAutorizadasService } from "src/app/services/paseronas-autorizadas.service";
import { VerificacionCertificadoService } from "src/app/services/verificacion-certificado.service";
import * as moment from "moment";
import { ExportModalComponent } from "../../layout/export-modal/export-modal.component";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-mantenedor-dte-compras",
	templateUrl: "./mantenedor-dte-compras.component.html",
	styleUrls: ["./mantenedor-dte-compras.component.scss"],
})
export class MantenedorDteComprasComponent implements OnInit {
	public loading: boolean = false;
	public rowsMantenedor: DteEmitido[] = [];
	SortType = SortType;
	public tracesModal: NgbModalRef;
	public anuladorModal: NgbModalRef;
	public senderDteModal: NgbModalRef;
	public detailModal: NgbModalRef;
	public configLocal = ConfigMantenedorDTE;
	public selected: DteEmitido[] = []; //dtes seleccionados por checkbox
	public selectedItem: DteEmitido; //dte seleccionado para envio individual y despliegue en modal
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public filter = new DteFilter();
	public page = new Page();
	public empresasSource: Emisor[] = [];
	public tipoDteSource: TipoDte[];
	public filterDescription: string;
	public emisorId: string;
	public sucursalId: string;
	public fileIdValue: string;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public senderForm: FormGroup;
	public dteToShow: DteEmitido = new DteEmitido();
	public tracesToShow: Traza[] = [];
	public dteToNullify: DteEmitido = new DteEmitido();
	public dteToNullifyReferences: IDte[] = [];
	public nombreTipoNota: string = "Anulación";
	private cesionDteModal: NgbModalRef;
	public componentStarted: boolean = false;
	public usuarioId: string;
	@ViewChild("tableMobile") tableRef: any;
	public superAdm = false;
	private closeActionsHandler: any;
	constructor(private dteService: DteEmitidosService, private datePipe: DatePipe, private ref: ChangeDetectorRef, 
		private validadorCertificadoService: VerificacionCertificadoService,
		private personasAutorizadasService: PersonasAutorizadasService, private localStorage: LocalStorageService, public utilities: UtilitiesService, public permissions: PermissionService, private modalService: NgbModal, private router: Router, private formBuilder: FormBuilder, private correoEnvioService: CorreoEnvioService, private emisorService: EmisorService, private tokenService: TokenStorageService, private sessionUserService: SessionUserService) {
		this.superAdm = this.tokenService.getUser().superAdmin;
		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		if (this.superAdm) {
			this.getEmisoresFullList();
		}
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.createSenderForm();
		this.emisorId = this.tokenService.getCompany();
		this.sucursalId = this.tokenService.getSubsidiary();
		this.filter.emisorId = this.emisorId;
		this.filter.sucursalId = this.sucursalId;
		this.filter.tipoDteId = this.tipoDteSource.find((t) => t.codigosii == 46).tipoDteId;
		this.filter.codigoSii = "46";
		this.filter.reutilizado = false;
		this.usuarioId = (this.tokenService.getUser() as SessionUser).id;
	}

	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
	  
	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }
	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.applyNavigationState(window.history.state);
		this.validarCertificado();
	}

	private applyNavigationState(state: any) {
		if (!state) {
			return;
		}
		this.fileIdValue = state["paramId"];
		this.filterDescription = state["filterDescription"];
		this.filter.importacionMasivaId = this.fileIdValue ? this.fileIdValue : "";
		const emisorImportado = state["filterEmisor"];
		const sucursalImportado = state["filterSucursal"];
		this.filter.emisorId = emisorImportado ? emisorImportado : this.emisorId;
		this.filter.sucursalId = sucursalImportado ? sucursalImportado : this.sucursalId;
	}

	private async validarCertificado() {
		const validacionCertificado = await this.validadorCertificadoService.validar();
		if (validacionCertificado) {
			this.setPage({ offset: 0 });
		}
	}

	searchElementsByFilter(event) {
		//se toman los valores del filtro que necesite el endpoint de filtro para dte
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);
		//this.filter.tipoDteId = event.tipoDteId != null ? event.tipoDteId : "";
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter.reutilizado = event.reutilizado ? true : false;
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.filter.estadoSii = event.estadoDte;
		this.filter.sucursalId = event.sucursalId ? event.sucursalId : this.sucursalId;
		this.filter.emisorId = event.emisorId ? event.emisorId : this.emisorId;
		this.setPage({ offset: 0 });
	}

	filterConcordance(configCriterias, dteFilter: DteFilter, eventFilter): DteFilter {
		//vaciar del dteFilter aquellos campos distinto al presnetado en el eventFilter actual, segun el arreglo configCriterias
		configCriterias.forEach((criteria) => {
			if (criteria != eventFilter.criterio) {
				dteFilter[criteria] = "";
			}
		});
		return dteFilter;
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		//llamada generica a los dte paginados
		this.dteService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as DteEmitido[];
					this.ref.detectChanges();
					elements.forEach((row) => {
						this.setEmisorToElement(row);
						this.setTipoDteToElement(row);
					});
					this.rowsMantenedor = [...elements];
					this.ref.detectChanges();
					this.setPagefromResponse(this.page, pagedData);
				},
				(error) => {
					Swal.fire({
						icon: "error",
						title: "Error en la solicitud",
						text: this.utilities.setErrorMessageFromArray(error.error),
					});
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}
	setEmisorToElement(row: IDte) {
		if (row.emisorId) {
			let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.emisorId);
			row.emisorAsociado = empresaAsociada;
		}
	}
	setTipoDteToElement(row: IDte) {
		if (row.tipoDteId) {
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.tipoDteId == row.tipoDteId);
			row.nombreTipoDte = tipoDteAsociado.abreviacion;
		}
	}
	setPagefromResponse(currentPage: Page, data: PagedResponse<DteEmitido>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	multipleDocumentDownload(fileType) {
		if (this.selected.length > 0) {
			this.loading = true;
			let dteIds = this.selected.map(dte => dte.dteId);
			this.getDownloadFilesObservable(dteIds, fileType).subscribe(
                (response) => {
                    const blob = new Blob([response], { type: 'application/zip' });
                    const dateOfDownLoad = this.datePipe.transform(Date.now(), 'dd/MM/yyyy');
                    FileSaver.saveAs(blob, `documentos_${dateOfDownLoad}_${fileType}.zip`);
                    Swal.fire({
						icon: "success",
						title: "Descarga de documentos",
						text: "Los documentos seleccionados se han descargado.",
					});
                },
                (err) => {
					this.loading = false;
					this.ref.detectChanges();
					console.log(err);					
					Swal.fire({
						icon: "error",
						title: "Error en exportación",
						text: "No ha sido posible descargar los documentos seleccionados.\nFavor intentar mas tar de o contactar a su administrador. " + this.utilities.setErrorMessageFromArray(err.error),
					});
                },
                () => {
                    this.loading = false;
					this.ref.detectChanges();
                }
            );
		}
		else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}

	getDownloadFilesObservable(Ids: string[], type: string): Observable<any> {
		const downloadRequest = {
            dteIds: Ids,
            fileType: type
        };
		return this.dteService.getZip(downloadRequest);
	}

	getDownloadXmlObservable(id: string): Observable<Response<any>> {
		return this.dteService.getXml(id);
	}

	getDownloadPdfObservable(id: string, tipoDte: number): Observable<Response<any>> {
		if (tipoDte == 43) return this.dteService.getPdfLiquidacion(id);
		else return this.dteService.getPdf(id);
	}

	navigateToFacturador(type: InvoiceType) {
		if (!(this.permissions.canIssueInvoice(type))) { return; }
		this.router.navigateByUrl("facturador-individual", {
			state: { invoiceType: type },
		});
	}
	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}

	getId(row) {
		return row.dteId;
	}

	sortDate(propA, propB, rowA, rowB) {
		if (new Date(propA))
			if (propA instanceof Date && propB instanceof Date) {
				if (propA < propB) return -1;
				if (propA > propB) return 1;
			}
	}
	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((dte) => {
					this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((dte) => {
				this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	getCellClass({ row, column, value }): any {
		return row.codigoTipoDte === 61 ? "is-monto-nota-credito number-table-alignment" : "number-table-alignment";
	}

	createSenderForm() {
		this.senderForm = this.formBuilder.group(
			{
				receiverEmail: ["", [Validators.required, MultipleEmailValidator, Validators.maxLength(320)]],
				ccEmail: ["", [MultipleEmailValidator, Validators.maxLength(320)]],
				ccoEmail: ["", [MultipleEmailValidator, Validators.maxLength(320)]],
				sendPdfCheckbox: [true],
				sendXmlCheckbox: [true],
				comments: [""],
			},
			{ validators: SameWordEmailValidator }
		);
	}

	onSubmitSenderForm() {
		if (this.senderForm.valid) {
			let emailReceivers: string[] = this.senderForm.controls.receiverEmail.value.toString().split(",");
			let emailsCCs: string[] = this.senderForm.controls.ccEmail.value ? this.senderForm.controls.ccEmail.value.toString().split(",") : [];
			let emailCCOs: string[] = this.senderForm.controls.ccoEmail.value ? this.senderForm.controls.ccoEmail.value.toString().split(",") : [];
			var mailRequest = new SendInvoiceRequest();
			mailRequest.ccos = emailCCOs;
			mailRequest.ccs = emailsCCs;
			mailRequest.dteId = this.selectedItem.dteId;
			mailRequest.dteType = this.selectedItem.codigoTipoDte;
			mailRequest.to = emailReceivers;
			mailRequest.emailType = 3;
			mailRequest.pdf = this.senderForm.controls.sendPdfCheckbox.value ? true : false;
			mailRequest.xml = this.senderForm.controls.sendXmlCheckbox.value ? true : false;
			mailRequest.comments = this.senderForm.controls.comments.value;
			if (mailRequest.pdf || mailRequest.xml) {
				if (!this.selectedItem && this.selected.length == 1) {
					this.sendDteDocuments(mailRequest);
				} else if (this.selectedItem) {
					this.sendDteDocuments(mailRequest);
				} else if (this.selected.length != 1) {
					//opcion temporal para solicitar solo un elemento
					Swal.fire({
						icon: "error",
						title: "Error de Selección",
						text: "Solo puede seleccionar un elemento para el envío.\nFavor seleccionar un documento con la columna selectora o usar la emisión individual desde el icono de 'Enviar Correo'",
					});
					return;
				}
			} else {
				Swal.fire({
					title: "Documentos No Seleccionados",
					text: "Favor indicar por lo menos un documento a enviar",
					icon: "info",
				});
				return;
			}
		}
	}

	sendDteDocuments(request: SendInvoiceRequest) {
		this.loading = true;
		this.ref.detectChanges();
		this.correoEnvioService.sendEmail(request).subscribe(
			(result) => {
				let resumenEnvioCorreo: string = "";
				resumenEnvioCorreo = "Se envió el documento a las siguientes direcciones:<br>" + request.to + "<br>";
				if (request.ccs[0] != "") {
					if (request.ccs.length > 0) {
						resumenEnvioCorreo += "<br> Con copia a las siguientes direcciones:<br>" + request.ccs + "<br>";
					}
				}
				if (request.ccos[0] != "") {
					if (request.ccos.length > 0) {
						resumenEnvioCorreo += "<br> Con copia oculta para las siguientes direcciones:<br>" + request.ccos;
					}
				}
				Swal.fire({
					icon: "success",
					title: "Envío exitoso",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + resumenEnvioCorreo + "</p></div>",
				});
				this.senderDteModal.close();
				this.senderForm.reset();
				this.senderForm.controls.ccEmail.patchValue("");
				this.senderForm.controls.ccoEmail.patchValue("");
				this.senderForm.controls.receiverEmail.patchValue("");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en el envío",
					text: "No fue posible enviar el documento. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	openDocumentSenderModal(modalRef, row?: DteEmitido) {
		if (row) {
			this.selectedItem = row;
		} else if (this.selected.length > 0) {
			this.selectedItem = undefined;
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora o usar la emisión individual desde el icono de 'Enviar Correo'",
			});
			return;
		}

		this.senderDteModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});

		this.senderDteModal.closed.subscribe((res) => {
			this.senderForm.reset();
		});
		this.senderDteModal.dismissed.subscribe((res) => {
			this.senderForm.reset();
		});
	}

	responseToPdfDownload(responseB64, currentDte: DteEmitido) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, currentDte.folio + "_dte.pdf");
		this.loading = false;
		this.ref.detectChanges();
	}

	downloadPDF(dte: DteEmitido) {
		this.loading = true;
		if (dte.codigoTipoDte == 43) {
			this.dteService.getPdfLiquidacion(dte.dteId).subscribe(
				(result) => {
					this.responseToPdfDownload(result.data, dte);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error al descargar pdf",
						text: "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			);
		} else {
			this.dteService.getPdf(dte.dteId).subscribe(
				(result) => {
					this.responseToPdfDownload(result.data, dte);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error al descargar pdf",
						text: "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			);
		}
	}
	downloadPDFCedible(dte: DteEmitido, cedible: boolean) {
		this.loading = true;
		this.dteService.getPdfCedible(dte.dteId, cedible).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, dte);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al descargar pdf cedible",
					text: "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	downloadXml(dte: DteEmitido) {
		this.dteService.getXml(dte.dteId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				FileSaver.saveAs(blobXml, dte.folio + "_" + "dte.xml");
				this.loading = false;
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Error en XML",
					text: this.utilities.setErrorMessageFromArray(error.error),
				});
				this.loading = false;
			},
			() => {
				this.loading = false;
			}
		);
	}

	//trazabilidad
	openTraceShowModal(modalRef, dte: DteEmitido) {
		this.dteToShow = dte;
		this.loading = true;
		this.dteService
			.getTrace(this.dteToShow.dteId)
			.subscribe(
				(result) => {
					this.tracesToShow = result.data as Traza[];
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						icon: "error",
						title: "Error en Trazabilidad",
						text: "No es posible obtener la trazabilidad de este documento. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(error.error),
					});
				},
				() => {
					this.loading = false;
				}
			)
			.add(() => {
				this.loading = false;
				this.tracesModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "lg",
					centered: true,
				});
			});
	}
	get mostrarMsgSii(): boolean {
		const estado = this.dteToShow?.estadoSii;
		const hayCorreo = this.tracesToShow?.some(
			t => t.descripcion?.toLowerCase().includes('validación desde correo')
		);
		return (estado === 5 || estado === 7) && !hayCorreo;
	}

	
	getComuna(dteToShow: any): string {
		if (dteToShow.proveedor?.comuna && 
			typeof dteToShow.proveedor.comuna === 'string' && 
			dteToShow.proveedor.comuna.trim() !== '') {
			return dteToShow.proveedor.comuna;
		}
		if (dteToShow.receptorAsociado?.comuna && 
			typeof dteToShow.receptorAsociado.comuna === 'string' && 
			dteToShow.receptorAsociado.comuna.trim() !== '') {
			return dteToShow.receptorAsociado.comuna;
		}
		return "Sin Comuna";
	}

	getCiudad(dteToShow: any): string {
		if (dteToShow.proveedor?.ciudad && 
			typeof dteToShow.proveedor.ciudad === 'string' && 
			dteToShow.proveedor.ciudad.trim() !== '') {
			return dteToShow.proveedor.ciudad;
		}
		if (dteToShow.receptorAsociado?.ciudad && 
			typeof dteToShow.receptorAsociado.ciudad === 'string' && 
			dteToShow.receptorAsociado.ciudad.trim() !== '') {
			return dteToShow.receptorAsociado.ciudad;
		}
		return "Sin Ciudad";
	}

	detailOpenModal(modalRef, row: DteEmitido) {
		this.dteToShow = row;
		this.loading = true;
		let proveedor: any;
		if (row.codigoTipoDte == 46) {
			this.dteService
				.getProveedorDte(row.dteId)
				.subscribe(
					(res) => {
						if (res?.data) {
							proveedor = res.data;
							return;
						}

						Swal.fire({
							icon: "error",
							title: "Proveedor no disponible",
							text: "No fue posible obtener los datos del proveedor del documento indicado.",
						});
					},
					(err) => {
						Swal.fire({
							icon: "error",
							title: "Error al obtener detalles",
							text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
						});
					}
				)
				.add(() => {
					if (!proveedor) {
						this.loading = false;
						this.ref.detectChanges();
						return;
					}

					this.dteService
						.getDetalleDte(row.dteId)
						.subscribe(
							(res) => {
								this.dteToShow.detalleDte = res.data;
								if (this.dteToShow.detalleDte && this.dteToShow.detalleDte.length > 0) {
									this.dteToShow.impuestos = 0;
									this.dteToShow.detalleDte.forEach((detalle) => {
										this.dteToShow.impuestos += detalle.totalImpuestosAdicionales;
									});
								}
							},
							(err) => {
								Swal.fire({
									icon: "error",
									title: "Error al obtener detalles",
									text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
								});
							}
						)
						.add(() => {
							this.dteService
								.getInfoDetalleDte(row.dteId)
								.subscribe(
									(result) => {
										this.dteToShow.observaciones = result.dteEmitido.observaciones;
										this.dteToShow.proveedor = proveedor;
										this.dteToShow.impuestos = this.dteToShow.detalleDte.reduce((suma, detalle) => (suma += detalle.totalImpuestosAdicionales), 0);
										this.ref.detectChanges();
									},
									(error) => {
										this.loading = false;
										this.ref.detectChanges();
										Swal.fire({
											icon: "error",
											title: "Error al obtener detalles",
											text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error),
										});
									}
								)
								.add(() => {
									this.loading = false;
									this.ref.detectChanges();
									this.detailModal = this.modalService.open(modalRef, {
										windowClass: "",
										size: "lg",
										centered: true,
									});
								});
						});
				});

		} else if (row.codigoTipoDte == 43) {
			this.dteService
				.getReceptorDteLiquidacion(row.dteId)
				.subscribe(
					(res) => {
						this.dteToShow.receptorAsociado = res.data;
					},
					(err) => {
						Swal.fire({
							icon: "error",
							title: "Error al obtener detalles",
							text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
						});
					}
				)
				.add(() => {
					this.dteService.getDetalleDte(row.dteId).subscribe(
						(res) => {
							this.dteToShow.detalleDte = res.data;
						},
						(err) => {
							Swal.fire({
								icon: "error",
								title: "Error al obtener detalles",
								text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
							});
						}
					);
				})
				.add(() => {
					this.dteService
						.getComisionesDte(row.dteId)
						.subscribe(
							(res) => {
								this.dteToShow.comisionesCargosDte = res.data;
								this.dteToShow.comisionCargo = 0;
								this.dteToShow.comisionesCargosDte.forEach((detalle) => {
									this.dteToShow.comisionCargo += detalle.total;
								});
							},
							(err) => {
								Swal.fire({
									icon: "error",
									title: "Error al obtener comisiones",
									text: "No fue posible obtener las comisiones del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
								});
							}
						)
						.add(() => {
							this.loading = false;
							this.ref.detectChanges();
							this.detailModal = this.modalService.open(modalRef, {
								windowClass: "",
								size: "lg",
								centered: true,
							});
						});
				});
		} else if (row.codigoTipoDte == 56 || row.codigoTipoDte == 61) {
			//calling dte references for shiwing its details
			this.dteService
				.getReferenciasDte(row.dteId)
				.subscribe(
					(result) => {
						let dteReferences = result.data as ReferenciaDte[];
						dteReferences.forEach((ref) => {
							if (ref.dte) {
								this.setEmisorToElement(ref.dte);
								this.setTipoDteToElement(ref.dte);
							}
						});
						row.listaReferencias = dteReferences;
					},
					(error) => {
						Swal.fire({
							icon: "error",
							title: "Error al obtener detalles",
							text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error),
						});
					}
				)
				.add(() => {
					this.dteService
						.getReceptorDte(row.dteId)
						.subscribe(
							(res) => {
								this.dteToShow.receptorAsociado = res.data;
							},
							(err) => {
								Swal.fire({
									icon: "error",
									title: "Error al obtener detalles",
									text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
								});
							}
						)
						.add(() => {
							this.dteService
								.getDetalleDte(row.dteId)
								.subscribe(
									(res) => {
										this.dteToShow.detalleDte = res.data;
									},
									(err) => {
										Swal.fire({
											icon: "error",
											title: "Error al obtener detalles",
											text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
										});
									}
								)
								.add(() => {
									this.loading = false;
									this.ref.detectChanges();
									this.detailModal = this.modalService.open(modalRef, {
										windowClass: "",
										size: "lg",
										centered: true,
									});
								});
						});
				});
		} else {
			this.dteService
				.getReceptorDte(row.dteId)
				.subscribe(
					(res) => {
						this.dteToShow.receptorAsociado = res.data;
					},
					(err) => {
						Swal.fire({
							icon: "error",
							title: "Error al obtener detalles",
							text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
						});
					}
				)
				.add(() => {
					this.dteService
						.getDetalleDte(row.dteId)
						.subscribe(
							(res) => {
								this.dteToShow.detalleDte = res.data as DetalleDte[];
								this.ref.detectChanges();
								this.dteToShow.impuestos = this.dteToShow.detalleDte.reduce((suma, detalle) => (suma += detalle.totalImpuestosAdicionales), 0);
							},
							(err) => {
								Swal.fire({
									icon: "error",
									title: "Error al obtener detalles",
									text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error),
								});
							}
						)
						.add(() => {
							this.dteService
								.getInfoDetalleDte(row.dteId)
								.subscribe(
									(result) => {
										this.dteToShow.descuentoGlobal = result.descuentoRecargos != null && result.descuentoRecargos.length > 0 ? result.descuentoRecargos[0].valor : undefined;
										this.dteToShow.receptorAsociado.razonSocial = result.receptor.razonSocial;
										this.dteToShow.receptorAsociado.rutString = result.receptor.rutString;
									},
									(error) => {
										this.loading = false;
										this.ref.detectChanges();
										Swal.fire({
											icon: "error",
											title: "Error al obtener detalles",
											text: "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error),
										});
									}
								)
								.add(() => {
									this.loading = false;
									this.ref.detectChanges();
									this.detailModal = this.modalService.open(modalRef, {
										windowClass: "",
										size: "lg",
										centered: true,
									});
								});
						});
				});
		}
	}

	openAnularDteModal(modalRef, dte: DteEmitido) {
		this.dteToNullify = dte;
		this.loading = true;
		this.dteService
			.getDetalleDte(dte.dteId)
			.subscribe(
				(result) => {
					this.ref.detectChanges();
					this.dteToNullify.detalleDte = result.data as DetalleDte[];
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						icon: "error",
						title: "Error en anulación",
						text: "No es posible obtener los detalles del documento a anular",
					});
				},
				() => {}
			)
			.add(() => {
				this.dteService
					.getReferencias(dte.dteId)
					.subscribe(
						(result) => {
							let dteReferences = result.data.map((ref) => {
								return ref.dte;
							});
							dteReferences.forEach((row) => {
								this.setEmisorToElement(row);
								this.setTipoDteToElement(row);
							});
							this.dteToNullifyReferences = dteReferences;
						},
						(error) => {
							this.loading = false;
							Swal.fire({
								icon: "error",
								title: "Error en anulación",
								text: "No es posible obtener los detalles del documento a anular. " + this.utilities.setErrorMessageFromArray(error.error),
							});
						}
					)
					.add(() => {
						this.dteService.getReceptorDte(dte.dteId).subscribe(
							(result) => {
								this.loading = false;
								this.ref.detectChanges();
								this.dteToNullify.receptorAsociado = result.data;
								this.anuladorModal = this.modalService.open(modalRef, {
									windowClass: "",
									size: "lg",
								});
							},
							(error) => {
								this.loading = false;
								Swal.fire({
									icon: "error",
									title: "Error en anulación",
									text: "No es posible obtener los detalles del documento a anular. " + this.utilities.setErrorMessageFromArray(error.error),
								});
							}
						);
					});
			});
	}

	closeAnularDteModal() {
		this.anuladorModal.close();
	}

	newCreditNote(data: NotaCredito) {
		let notaCreditoDte = new DteEmitido();
		notaCreditoDte.nombreTipoDte = "Nota de Crédito Electrónica";
		notaCreditoDte.folio = 1000;
		notaCreditoDte.emisorAsociado = data.dteReferencia.emisorAsociado;
		notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv || data.dteReferencia.proveedor.dv;
		notaCreditoDte.razonSocial = data.dteReferencia.razonSocial || data.dteReferencia.proveedor.razonSocial;
		notaCreditoDte.rutReceptor = data.dteReferencia.rutReceptor || data.dteReferencia.proveedor.rutProveedor;
		notaCreditoDte.fecha = new Date();
		if (data.tipoNota == 0) {
			notaCreditoDte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			notaCreditoDte.total = 0;
		} else {
			notaCreditoDte.total = data.total;
		}
		this.loading = true;
		if (data.dteReferencia.codigoTipoDte == 110) {
			this.dteService.creditNoteDteExportNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					notaCreditoDte.dteId = dteResult.dteId;
					notaCreditoDte.folio = dteResult.folio;
					notaCreditoDte.estadoSii = dteResult.estadoSii;
					notaCreditoDte.nombreTipoDte = "NC.EX.E";
					notaCreditoDte.codigoTipoDte = 112;
					notaCreditoDte.anulado = false;
					notaCreditoDte.notaCreditoHabilitada = false;
					notaCreditoDte.notaDebitoHabilitada = true;
					notaCreditoDte.rutReceptor = data.dteReferencia.rutReceptor;
					notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
					notaCreditoDte.neto = data.tipoNota == 0 ? data.dteReferencia.neto : data.neto;
					notaCreditoDte.iva = data.tipoNota == 0 ? data.dteReferencia.iva : data.iva;
					notaCreditoDte.exento = data.dteReferencia.exento;
					//this.setTipoDteToElement(notaCreditoDte);
					this.rowsMantenedor.unshift(notaCreditoDte);
					this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Documento Generado",
						text: "Se ha generado el documento correctamente",
					});
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					let errorsMsg = "";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							errorsMsg += "\n" + errorMsg + "\n";
						});
					}
					Swal.fire({
						icon: "error",
						title: "Error en anulación",
						text: "Ha ocurrido un error al intentar generar el documento.\n" + errorsMsg,
					});
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			);
		} else {
			this.dteService.creditNoteNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					notaCreditoDte.dteId = dteResult.dteId;
					notaCreditoDte.folio = dteResult.folio;
					notaCreditoDte.estadoSii = dteResult.estadoSii;
					notaCreditoDte.nombreTipoDte = "N.C.E";
					notaCreditoDte.codigoTipoDte = 61;
					notaCreditoDte.anulado = false;
					notaCreditoDte.notaCreditoHabilitada = false;
					notaCreditoDte.notaDebitoHabilitada = true;
					notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv || data.dteReferencia.proveedor.dv;
					notaCreditoDte.razonSocial = data.dteReferencia.razonSocial || data.dteReferencia.proveedor.razonSocial;
					notaCreditoDte.rutReceptor = data.dteReferencia.rutReceptor || data.dteReferencia.proveedor.rutProveedor;
					notaCreditoDte.neto = data.tipoNota == 0 ? data.dteReferencia.neto : data.neto;
					notaCreditoDte.iva = data.tipoNota == 0 ? data.dteReferencia.iva : data.iva;
					notaCreditoDte.exento = data.dteReferencia.exento;
					//this.setTipoDteToElement(notaCreditoDte);
					this.rowsMantenedor.unshift(notaCreditoDte);
					this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Documento Generado",
						text: "Se ha generado el documento correctamente",
					});
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					let errorsMsg = "";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							errorsMsg += "\n" + errorMsg + "\n";
						});
					}
					Swal.fire({
						icon: "error",
						title: "Error en anulación",
						text: "Ha ocurrido un error al intentar generar el documento.\n" + errorsMsg,
					});
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			);
		}
	}
	updateConditionOfDte(dteId: string, dteProperty: string, propertyValue: any) {
		let currentDte = this.rowsMantenedor.find((dte) => dte.dteId == dteId);
		if (currentDte) {
			currentDte[dteProperty] = propertyValue;
		}
	}

	getNullifyTypeName(event) {
		this.nombreTipoNota = event;
		this.ref.detectChanges();
	}
	newDebitNoteNullification(data: NotaDebito) {
		let dte = new DteEmitido();
		dte.nombreTipoDte = "Nota de Debito Electrónica";
		dte.folio = 1000;
		dte.emisorAsociado = data.dteReferencia.emisorAsociado;
		dte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		dte.razonSocial = data.dteReferencia.razonSocial;
		dte.fecha = new Date();
		if (data.tipoNota == 0) {
			dte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			dte.total = 0;
		} else {
			dte.total = data.total;
		}
		this.loading = true;
		if (data.dteReferencia.codigoTipoDte == 112) {
			this.dteService.debitNoteDteExportNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					dte.dteId = dteResult.dteId;
					dte.folio = dteResult.folio;
					dte.estadoSii = dteResult.estadoSii;
					dte.nombreTipoDte = "ND.EX.E";
					dte.codigoTipoDte = 111;
					dte.anulado = false;
					dte.notaCreditoHabilitada = false;
					dte.notaDebitoHabilitada = false;
					//this.setTipoDteToElement(dte);
					this.rowsMantenedor.unshift(dte);
					this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Documento Generado",
						text: "Se ha generado el documento correctamente",
					});
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					let errorsMsg = "";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							errorsMsg += "\n" + errorMsg + "\n";
						});
					}
					Swal.fire({
						icon: "error",
						title: "Error en anulación",
						text: "Ha ocurrido un error al intentar generar el documento.\n" + errorsMsg,
					});
				}
			);
		} else {
			this.dteService.debitNoteNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					dte.dteId = dteResult.dteId;
					dte.folio = dteResult.folio;
					dte.estadoSii = dteResult.estadoSii;
					dte.nombreTipoDte = "N.D.E";
					dte.codigoTipoDte = 56;
					dte.anulado = false;
					dte.notaCreditoHabilitada = false;
					dte.notaDebitoHabilitada = false;
					//this.setTipoDteToElement(dte);
					this.rowsMantenedor.unshift(dte);
					this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Documento Generado",
						text: "Se ha generado el documento correctamente",
					});
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					let errorsMsg = "";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							errorsMsg += "\n" + errorMsg + "\n";
						});
					}
					Swal.fire({
						icon: "error",
						title: "Error en anulación",
						text: "Ha ocurrido un error al intentar generar el documento.\n" + errorsMsg,
					});
				}
			);
		}
	}
	newDebitNoteInterest(data: NotaDebito) {
		let dte = new DteEmitido();
		dte.nombreTipoDte = "Nota de Crédito Electrónica";
		dte.folio = 1000;
		dte.emisorAsociado = data.dteReferencia.emisorAsociado;
		dte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		dte.razonSocial = data.dteReferencia.razonSocial;
		dte.fecha = new Date();
		if (data.tipoNota == 0) {
			dte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			dte.total = 0;
		} else {
			dte.total = data.total;
		}
		this.loading = true;
		this.dteService.debitNoteNullificationInterests(data).subscribe(
			(result) => {
				let dteResult = result.data as DteEmitido;
				dte.dteId = dteResult.dteId;
				dte.folio = dteResult.folio;
				dte.estadoSii = dteResult.estadoSii;
				dte.nombreTipoDte = "N.D.E";
				dte.codigoTipoDte = 56;
				dte.anulado = false;
				dte.notaCreditoHabilitada = false;
				dte.notaDebitoHabilitada = false;
				//this.setTipoDteToElement(dte);
				this.rowsMantenedor.unshift(dte);
				this.rowsMantenedor = [...this.rowsMantenedor];
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Documento Generado",
					text: "Se ha generado el documento correctamente",
				});
				if (data.tipoNota == 0) {
					this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
				}
				this.anuladorModal.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				let errorsMsg = "";
				if (error.error.errors) {
					error.error.errors.forEach((errorMsg) => {
						errorsMsg += "\n" + errorMsg + "\n";
					});
				}
				Swal.fire({
					icon: "error",
					title: "Error en anulación",
					text: "Ha ocurrido un error al intentar generar el documento.\n" + errorsMsg,
				});
			}
		);
	}

	openCesionDte(modalRef, row) {
		this.selectedItem = row;
		this.loading = true;
		this.personasAutorizadasService.getAuthorizedPersonsByEmisor(row.emisorId).subscribe(
			(result) => {
				if (result.data.length > 0) {
					this.loading = false;
					row.emisorAsociado.personasAutorizadas = result.data;
					this.ref.detectChanges();
					this.cesionDteModal = this.modalService.open(modalRef, {
						windowClass: "",
						size: "lg",
					});
				} else {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						title: "Error en Personas Autorizadas",
						text: "El emisor actual no posee personas autorizadas, favor ingresar por lo menos una persona autorizada para realizar la Cesión del documento.",
						icon: "error",
					});
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					title: "Error en Personas Autorizadas",
					text: "No se pudo obtener la lista de personas  autirizadas, favor intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
					icon: "error",
				});
			}
		);
	}
	sendCesionDteRequest($event: CesionRequest) {
		this.loading = true;
		let usuario = (this.tokenService.getUser() as SessionUser).id;
		let subsidiary = this.tokenService.getSubsidiary();
		this.dteService.sendCesionRequest(usuario, subsidiary, $event).subscribe(
			(result) => {
				Swal.fire({
					icon: "success",
					title: "Cesión exitosa",
					text: "Se ha generado la cesión del documento",
				});
				this.loading = false;
				this.cesionDteModal.close();
				this.ref.detectChanges();
				this.router.navigateByUrl("/ventas/cesiones");
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Cesión fallida",
					text: "No ha podido generarse la cesión del documento." + this.utilities.setErrorMessageFromArray(error.error),
				});
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}
	closeCesionDteModal() {
		this.cesionDteModal.close();
	}
	negativeSettlement(dte: DteEmitido) {
		if (!(this.permissions.getPermission("40-21-10").asignado)) { return; }
		this.loading = true;
		let usuario = (this.tokenService.getUser() as SessionUser).id;
		let sucursalId = this.tokenService.getSubsidiary();
		this.dteService.sendDteNegativeSettlement(usuario, sucursalId, dte.dteId).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Liquidación Negativa Generada",
					text: "Se ha generado la liquidación negativa correctamente",
				});
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Liquidación Negativa Fallida",
					text: "No se ha podido generar la liquidación negativa del documento. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	setPageSize() {
		this.setPage({ offset: 0 });
	}

	resendDte(dte: DteEmitido) {
		this.loading = true;
		var request = new ActualizarEstadoSiiRequest();
		request.Dtes = [dte.dteId];
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.dteService.resendDte(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Estado Sii Actualizado",
					text: "El documento volverá a ser enviado al servicio de impuestos internos",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Actualizar Estado Sii",
					text: "No fue posible actualizar el estado sii del documento. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	resendEmailSii(dte: DteEmitido) {
		this.loading = true;
		var request = new ReenvioEmailRequest();
		request.dteId = dte.dteId;
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.dteService.resendEmailSii(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reenvio de Email Validación Sii",
					text: "La validación del documento desde el sii fue reenviada al email registrado en el servicio de impuestos internos",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al solicitar reenvio de correo de validación",
					text: "No fue posible solicitar el reenvio del correo de validación desde el sii. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	reuse(dte: DteEmitido) {
		this.loading = true;
		this.dteService.reuse(dte.dteId).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reutilización de Folio",
					text: res.message,
				});
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Solicitar Reutilización de Folio",
					text: "No fue posible solicitar la reutilización de folio. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	tryMassiveRouseConfirm() {
		if (this.selected.length > 0) {
			var valid = false;
			var ids: string[] = [];
			var invalidList = this.selected.filter((x) => x.estadoSii == 6 || x.estadoSii == 7);
			if (invalidList.length > 0) {
				Swal.fire({
					icon: "error",
					title: "Error de Selección",
					text: "Solo se pueden reutilizar folios de documentos que no estén aceptados por el sii",
				});
				return;
			}
			Swal.fire({
				icon: "info",
				title: "Reutilizar folios",
				text: "¿Está seguro de reutilizar los folios de los documentos seleccionados?",
				confirmButtonText: "Continuar",
				confirmButtonColor: "#1BC5BD",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				cancelButtonColor: "#F64E60",
			}).then((res) => {
				if (res.isConfirmed) {
					this.massiveReuse();
				} else {
					return;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento válido para reutilizar.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}
	massiveReuse() {
		if (this.selected.length > 0) {
			var valid = false;
			var ids: string[] = [];
			var invalidList = this.selected.filter((x) => x.estadoSii == 6 || x.estadoSii == 7);
			if (invalidList.length > 0) {
				Swal.fire({
					icon: "error",
					title: "Error de Selección",
					text: "Solo se pueden reutilizar folios de documentos que no estén aceptados por el sii",
				});
			} else {
				this.selected.forEach((dte) => {
					ids.push(dte.dteId);
				});
				this.loading = true;
				var request = new ReutilizacionMasivaRequest();
				request.ids = ids;
				request.usuarioId = this.usuarioId;
				this.dteService.massivereuse(request).subscribe(
					(res) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Reutilización de Folios Masivo",
							text: res.message,
						});
						this.setPage({ offset: 0 });
						this.selected = [];
					},
					(error) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error al Solicitar Reutilización de Folios Masivo",
							text: "No fue posible solicitar la reutilización de folios masivo. " + this.utilities.setErrorMessageFromArray(error.error),
						});
					}
				);
			}
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento valido para reutilizar.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}
	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.empresasSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "MM/YYYY",
	};
	
	openExportModal() {
		const modalRef = this.modalService.open(ExportModalComponent, {
		  size: 'md',
		  centered: true
		});
	    modalRef.componentInstance.locale = this.locale;	  
		modalRef.componentInstance.filter = { ...this.filter };
		modalRef.componentInstance.type = 46;
		modalRef.componentInstance.totalItems = 15000;					
		modalRef.componentInstance.getPagedDataFunction = this.getDataToExport.bind(this);
		modalRef.componentInstance.exportData.subscribe((loadingStatus) => {
		  this.loading = loadingStatus;
		  this.ref.detectChanges();
		});
	  }

	  getDataToExport(filter: DteFilter, totalEments: number): Observable<PagedResponse<DteEmitido>> {
		let fullPage: Page = new Page();
		fullPage.pageSize = totalEments;
		fullPage.pageNumber = 0;
		fullPage.totalElements = totalEments;
		fullPage.totalPages = 1;
		this.loading = true;
		return this.dteService.getDataByPage(filter, fullPage);
	  }	 
}
